"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
const PartialError_1 = require("@juvare/common-web-ui/PartialError");
const hooks_1 = require("../../../ui/hooks");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const Image = (props) => {
    const { data: imageDataUrl, isLoading, error } = (0, hooks_1.useAttachmentDataUrl)(props.entity, props.entityId, props.attachmentKey, props.version);
    if (error) {
        return react_1.default.createElement(PartialError_1.PartialError, { error: error });
    }
    if (isLoading) {
        return (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'center', ...props.sx } },
            react_1.default.createElement(material_1.CircularProgress, null)));
    }
    return react_1.default.createElement(material_1.Box, { component: 'img', sx: props.sx, src: imageDataUrl, "data-test": props['data-test'], alt: props.alt });
};
exports.Image = Image;
